const DEFAULT_HOOKS = ['activate', 'mount', 'update'];

export { DEFAULT_HOOKS };
//# sourceMappingURL=constants.js.map
